/** @jsx jsx */
import { CModal, CModalBody, CModalFooter, CModalHeader } from "@coreui/react"
import { css, jsx } from "@emotion/react"
import PropTypes from "prop-types"
import { Fragment } from "react"
import { useSelector } from "react-redux"

import { CMSButton } from "../button"

const routeWarningModalStyles = css`
  .route-warning-modal {
    background-color: #fff;
    color: #1e1e2d;
    font-family: Poppins;

    .header-styles {
      border-bottom: none;
      font-size: 24px;
      font-weight: 600;
    }

    .footer-styles {
      border-top: none;
    }
  }
`

const ServiceActionModal = (props) => {
  const { isOpen, onCancel, onContinue } = props
  const projectName = useSelector((state) => {
    return state.user?.accounts?.project_name
  })

  return (
    <div css={routeWarningModalStyles}>
      <CModal
        show={isOpen}
        onClose={onCancel}
        centered
        className="random"
        addContentClass={"route-warning-modal"}
      >
        <CModalHeader closeButton className="header-styles">
          Confirm Navigation
        </CModalHeader>
        <CModalBody className="pb-5">
          <Fragment>
            <div>
              {projectName} and Deloitte CMS have ITSM data dynamically synced
              across organizations. Tickets should be created in your tool.
            </div>
            <div>
              Please use this option only if the sync is not working properly.
            </div>
          </Fragment>
        </CModalBody>
        <CModalFooter className="footer-styles">
          <CMSButton type="primary" outline={true} onClick={onCancel}>
            Cancel
          </CMSButton>

          <CMSButton
            type="primary"
            onClick={onContinue}
            data-tut="service-request-bt"
          >
            Continue
          </CMSButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

ServiceActionModal.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onContinue: PropTypes.func
}

export default ServiceActionModal
